import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const DonutChart = ({ data, darkMode }) => {
  // Dark mode theme configuration
  const chartTheme = darkMode
    ? {
        backgroundColor: '#234046',
        textColor: '#FFFFFF',
        gridLineColor: '#3B3B3B',
        lineColor: '#575757',
      }
    : {
        backgroundColor: '#FFFFFF',
        textColor: '#2B2B2B',
        gridLineColor: '#E6E6E6',
        lineColor: '#CCCCCC',
      };

  const options = {
    chart: {
      type: 'pie',
      height: 420,
      backgroundColor: chartTheme.backgroundColor,
    },

    title: {
      text: data.title || '',
      style: {
        color: chartTheme.textColor,
      },
    },

    tooltip: {
      pointFormat: `<b>{point.percentage:.1f}%`,
      backgroundColor: darkMode ? '#3B3B3B' : '#FFFFFF',
      borderColor: darkMode ? '#575757' : '#CCCCCC',
      style: {
        color: chartTheme.textColor,
      },
    },

    plotOptions: {
      pie: {
        innerSize: '60%',
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: `{point.y}${data.unit || ''}`,
          distance: 20,
          style: {
            color: chartTheme.textColor,
            textOutline: 'none',
          },
        },
        showInLegend: true,
      },
    },

    series: [
      {
        name: data.label || '',
        data: data.series?.[0]?.data.map((item) => ({
          name: item.name,
          y: item.value,
        })),
      },
    ],

    /* ---------- DESKTOP DEFAULT ---------- */
    legend: {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemStyle: {
        color: chartTheme.textColor,
      },
      itemHoverStyle: {
        color: darkMode ? '#FFFFFF' : '#000000',
      },
    },

    /* ---------- MOBILE RESPONSIVE ---------- */
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 768, // 📱 mobile breakpoint
          },
          chartOptions: {
            chart: {
              height: 360,
            },
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal',
            },
            plotOptions: {
              pie: {
                innerSize: '55%',
                dataLabels: {
                  distance: 10,
                },
              },
            },
          },
        },
      ],
    },

    credits: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default DonutChart;
